import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { BaseService } from "../base.service";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class SearchService extends BaseService {
  constructor(http: Http, cookieService: CookieService) {
    super(http, cookieService);
    this.init("search-products");
  }

  getSuggestions(query, listId, filters) {
    let headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Authorization", this.getAuthToken());
    let item = {
      query: query,
      filters: filters,
      list_id: listId
    };

    return this.http
      .post(this.baseURL(), JSON.stringify(item), { headers: headers })
      .toPromise()
      .then(response => {
        return response.json();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/search/search.service.ts